export default __webpack_public_path__ + "static/media/powered-by.cd12c24e.svg";